// Force-download a Supabase signed URL instead of previewing it inline.
//
// Supabase storage honours a `download` query param as a
// `Content-Disposition: attachment` directive, and that param is NOT part of
// the URL signature — so it can be appended to an already-signed URL with no
// server round-trip. A cross-origin <a download> filename hint is ignored by
// browsers, so the server-side directive is what sets the saved filename.
export function buildDownloadUrl(url: string, fileName: string): string {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}download=${encodeURIComponent(fileName)}`;
}

// Trigger a browser download via a transient anchor — no stray blank tab and no
// SPA navigation (unlike window.open / location assignment).
export function downloadSignedUrl(url: string, fileName: string): void {
  const a = document.createElement('a');
  a.href = buildDownloadUrl(url, fileName);
  a.download = fileName;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
